package ru.villawonka.app.domain.usecase

import ru.villawonka.app.domain.model.LanguageDomain

class GetAvailableLanguagesUseCase {

    operator fun invoke(): List<LanguageDomain> = listOf(
        LanguageDomain.RU,
        LanguageDomain.EN
    )
}